import { rootApi } from 'root-api'

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    offerAvailabilityFetchAvailability: build.query({
      query: ({ eventTypeId, startDate, endDate, timezone }) => ({
        url: `/api/event_types/${eventTypeId}/availability`,
        method: 'POST',
        data: {
          origin: 'offer_time_slots',
          date: startDate,
          rangeStart: startDate,
          rangeEnd: endDate,
          timezone
        }
      })
    }),
  })
})

export const {
  useLazyOfferAvailabilityFetchAvailabilityQuery
} = api
